import ResetInputIcon from './component'

export default ResetInputIcon
